import { Tabs } from '@tonic/shared/components/ui'
import { TabsList } from '@tonic/shared/components/ui'
import { TabsTrigger } from '@tonic/shared/components/ui'
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../../../utils/cn';

export function RefillLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { value: 'dashboard', label: 'Dashboard', path: '/admin/re-commerce/refill' },
    { value: 'containers', label: 'Containers', path: '/admin/re-commerce/refill/containers' },
    { value: 'stations', label: 'Stations', path: '/admin/re-commerce/refill/stations' },
    { value: 'subscriptions', label: 'Subscriptions', path: '/admin/re-commerce/refill/subscriptions' },
    { value: 'returns', label: 'Returns', path: '/admin/re-commerce/refill/returns' },
    { value: 'analytics', label: 'Analytics', path: '/admin/re-commerce/refill/analytics' },
    { value: 'settings', label: 'Settings', path: '/admin/re-commerce/refill/settings' }
  ];

  const currentTab = tabs.find(tab => 
    location.pathname === tab.path || 
    (tab.value === 'dashboard' && location.pathname === '/admin/re-commerce/refill')
  )?.value || 'dashboard';

  return (
    <div className="h-full flex flex-col">
      <div className="border-b border-neutral-200 bg-white">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-semibold text-neutral-900">Refill Program</h1>
          <p className="text-sm text-neutral-500">
            Manage refillable containers, stations, and subscriptions - including our famous meatballs!
          </p>
        </div>
        <div className="px-6">
          <Tabs value={currentTab} onValueChange={(value) => {
            const tab = tabs.find(t => t.value === value);
            if (tab) navigate(tab.path);
          }}>
            <TabsList className="border-b-0">
              {tabs.map((tab) => (
                <TabsTrigger
                  key={tab.value}
                  value={tab.value}
                  className={cn(
                    'flex items-center gap-2 px-4 py-2',
                    'transition-colors duration-200'
                  )}
                >
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>
      </div>
      <div className="flex-1 overflow-auto bg-neutral-50">
        <Outlet />
      </div>
    </div>
  );
} 
